import ServiceBase from "base/baseService"

export default class EnderecoProdutoService extends ServiceBase {

    title = "Endereço de produto"
    pluralTitle = "Endereço de produtos"
    url = '/cadastro/produto/enderecoproduto'
    frontUrl = '/cadastro/produto/enderecoproduto'
    frontUrlList = '/cadastro/produto/enderecoprodutolist'
    primaryKey = 'codigo_endp'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        return data
    }

    prepareToSave({ data }) {

        delete data.meta

        return data

    }

}
